import * as Server from '@wix/ambassador-restaurants-v1-fulfillment-method/types';
import { DayOfWeek, DeliveryAreaType, FulfillmentMethodType, RadiusUnit } from '../../models';
export const MIN_FULFILLMENT_METHOD_NAME_LENGTH = 0;
export const MAX_FULFILLMENT_METHOD_NAME_LENGTH = 30;
export const MAX_DELIVERY_AREA_RADIUS = 1000;
export const MIN_ESTIMATED_DELIVERY_TIME_MINUTES = 1;
export const MAX_ESTIMATED_DELIVERY_TIME_MINUTES = 300;
export const DEFAULT_DELIVERY_TIME_MINUTES = 30;
export const MAX_PICKUP_INSTRUCTIONS_LENGTH = 250;
export const DEFAULT_FULFILLMENT_METHOD_ADDRESS_GEOLOCATION = {
  latitude: 37.774836,
  longitude: -122.387258
};
export const DEFAULT_TIMEZONE = 'America/Los_Angeles';
export const DEFAULT_FULFILLMENT_METHOD_ADDRESS = {
  geocode: DEFAULT_FULFILLMENT_METHOD_ADDRESS_GEOLOCATION,
  formattedAddress: 'San Francisco Bay Trail, San Francisco, CA 94158, USA'
};
export const EMPTY_WEEKLY_AVAILABILITY = {
  [DayOfWeek.SUNDAY]: {
    dayOfWeek: DayOfWeek.SUNDAY,
    availabilities: []
  },
  [DayOfWeek.MONDAY]: {
    dayOfWeek: DayOfWeek.MONDAY,
    availabilities: []
  },
  [DayOfWeek.TUESDAY]: {
    dayOfWeek: DayOfWeek.TUESDAY,
    availabilities: []
  },
  [DayOfWeek.WEDNESDAY]: {
    dayOfWeek: DayOfWeek.WEDNESDAY,
    availabilities: []
  },
  [DayOfWeek.THURSDAY]: {
    dayOfWeek: DayOfWeek.THURSDAY,
    availabilities: []
  },
  [DayOfWeek.FRIDAY]: {
    dayOfWeek: DayOfWeek.FRIDAY,
    availabilities: []
  },
  [DayOfWeek.SATURDAY]: {
    dayOfWeek: DayOfWeek.SATURDAY,
    availabilities: []
  }
};
export const DEFAULT_AVAILABILITY = {
  [DayOfWeek.SUNDAY]: {
    dayOfWeek: DayOfWeek.SUNDAY,
    availabilities: [{
      start: {
        hours: 0,
        minutes: 0
      },
      end: {
        hours: 23,
        minutes: 59
      }
    }]
  },
  [DayOfWeek.MONDAY]: {
    dayOfWeek: DayOfWeek.MONDAY,
    availabilities: [{
      start: {
        hours: 0,
        minutes: 0
      },
      end: {
        hours: 23,
        minutes: 59
      }
    }]
  },
  [DayOfWeek.TUESDAY]: {
    dayOfWeek: DayOfWeek.TUESDAY,
    availabilities: [{
      start: {
        hours: 0,
        minutes: 0
      },
      end: {
        hours: 23,
        minutes: 59
      }
    }]
  },
  [DayOfWeek.WEDNESDAY]: {
    dayOfWeek: DayOfWeek.WEDNESDAY,
    availabilities: [{
      start: {
        hours: 0,
        minutes: 0
      },
      end: {
        hours: 23,
        minutes: 59
      }
    }]
  },
  [DayOfWeek.THURSDAY]: {
    dayOfWeek: DayOfWeek.THURSDAY,
    availabilities: [{
      start: {
        hours: 0,
        minutes: 0
      },
      end: {
        hours: 23,
        minutes: 59
      }
    }]
  },
  [DayOfWeek.FRIDAY]: {
    dayOfWeek: DayOfWeek.FRIDAY,
    availabilities: [{
      start: {
        hours: 0,
        minutes: 0
      },
      end: {
        hours: 23,
        minutes: 59
      }
    }]
  },
  [DayOfWeek.SATURDAY]: {
    dayOfWeek: DayOfWeek.SATURDAY,
    availabilities: [{
      start: {
        hours: 0,
        minutes: 0
      },
      end: {
        hours: 23,
        minutes: 59
      }
    }]
  }
};
export const DEFAULT_PICKUP_METHOD = {
  name: 'Pickup',
  enabled: true,
  revision: '1',
  type: FulfillmentMethodType.PICKUP,
  pickupOptions: {
    instructions: undefined,
    address: DEFAULT_FULFILLMENT_METHOD_ADDRESS
  },
  timeZone: DEFAULT_TIMEZONE,
  weeklyAvailability: DEFAULT_AVAILABILITY
};
export const DEFAULT_DELIVERY_METHOD = {
  name: 'Delivery',
  enabled: true,
  minOrderPrice: 0,
  fee: 0,
  type: FulfillmentMethodType.DELIVERY,
  deliveryOptions: {
    deliveryArea: {
      type: DeliveryAreaType.RADIUS,
      radiusOptions: {
        minDistance: 0,
        maxDistance: 1,
        unit: RadiusUnit.MILES,
        centerPointAddress: DEFAULT_FULFILLMENT_METHOD_ADDRESS
      },
      postalCodeOptions: {
        countryCode: '',
        postalCodes: []
      }
    },
    deliveryTimeInMinutes: DEFAULT_DELIVERY_TIME_MINUTES
  },
  weeklyAvailability: DEFAULT_AVAILABILITY,
  timeZone: DEFAULT_TIMEZONE
};
export const DEFAULT_SERVER_DELIVERY_METHOD = {
  name: 'Delivery',
  enabled: true,
  revision: '1',
  type: Server.FulfillmentMethodType.DELIVERY,
  deliveryOptions: {
    deliveryArea: {
      type: Server.Type.RADIUS,
      radiusOptions: {
        maxDistance: '10',
        unit: Server.Unit.KILOMETERS,
        centerPointAddress: DEFAULT_PICKUP_METHOD.pickupOptions.address
      }
    },
    deliveryTimeInMinutes: DEFAULT_DELIVERY_TIME_MINUTES
  },
  availability: {} // TODO: add availability
};
export const MILES_COUNTRIES = ['US', 'LR', 'MM'];
//# sourceMappingURL=constants.js.map